import { render, staticRenderFns } from "./travelerMissionDetail.vue?vue&type=template&id=0470b0bf"
import script from "./travelerMissionDetail.vue?vue&type=script&lang=js"
export * from "./travelerMissionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports